import axios from '@/util/axios';
import { getSelectOptions } from '@/exceed';
import { handleAxiosError } from 'core/notifications';

export default async (selection) => {
  let audiences;

  try {
    ({ data: { data: audiences } } = await axios.get('/api/admin/audiences'));
  } catch (error) {
    return handleAxiosError(error);
  }

  return getSelectOptions(audiences, { selection });
};
